// Slider documentation:
// https://github.com/angular-slider/angularjs-slider

(function() {
    angular
        .module("devicesModule")
        .controller("DeviceTrackerDetailsController", DeviceTrackerDetailsController)

    DeviceTrackerDetailsController.$inject = [
        "$rootScope",
        "$scope",
        "$timeout",
        "$stateParams",
        "$uibModal",
        "trackersService",
        "devicesService",
        "telemetryService",
        "notesService",
        "userMessagingService"
    ]

    function DeviceTrackerDetailsController(
        $rootScope,
        $scope,
        $timeout,
        $stateParams,
        $uibModal,
        trackersService,
        devicesService,
        telemetryService,
        notesService,
        userMessagingService
    ){
        "use strict"

        $scope.generalFormData            = {}
        $scope.connectionFormData         = {}
        $scope.newQwsSensorSettings       = {}
        $scope.newSolarLightTowerSettings = {}
        $scope.newSpeedTrailerSettings    = {}
        $scope.newTrucksEnterSettings     = {}
        $scope.newBeaconTrailerSettings   = {}
        $scope.newMarkerSettings          = {}

        $scope.notesAddNew         = false
        $scope.notesAddNewPrivate  = false
        $scope.notesNewText        = ""
        $scope.notesNewTextPrivate = ""

        $scope.editConnection = false

        $scope.enableAlerts              = true
        $scope.activeUseInWZ             = false
        $scope.inEnabledWZ               = false
        $scope.disableDOTAccess          = false
        $scope.liveTrackingPending       = false
        $scope.remoteOverridePending     = false
        $scope.isEditGeneral             = false
        $scope.isEditTrucksEnterSettings = false
        $scope.isEditMarkerSettings      = false
        $scope.isEditQwsSensorSettings   = false
        $scope.isEditSystemVoltage       = false
        $scope.isSettingSystemVoltage    = false
        $scope.isEditVoltageLimit        = false
        $scope.isSettingVoltageLimit     = false
        $scope.isResettingActiveMinutes  = false

        const Min_Distance = 1.5
        const Max_Distance = 32.0
        const Min_BeaconActivation = 5
        const Max_BeaconActivation = 900

        const updateDisplay = () => {

            if ($scope.tracker.telemetry.hasOwnProperty("voltage_battery") && $scope.tracker.telemetry.voltage_battery > 0) {
                $scope.battery_health = telemetryService.getBatteryHealth($scope.tracker.telemetry.voltage_battery, $scope.tracker.system_voltage)
            } else if ($scope.tracker.telemetry.hasOwnProperty("voltage")) {
                $scope.battery_health = telemetryService.getBatteryHealth($scope.tracker.telemetry.voltage, $scope.tracker.system_voltage)
            }

            if ($scope.tracker.hasOwnProperty("system_voltage")) {
                if ($scope.tracker.system_voltage === $scope.systemVoltageOptions[0].value) {
                    $scope.selectedSystemVoltage = $scope.systemVoltageOptions[0]
                } else {
                    $scope.selectedSystemVoltage = $scope.systemVoltageOptions[1]
                }
            }

            $scope.activeUseInWZ    = $scope.tracker.device.active_use_in_wz
            $scope.inEnabledWZ      = $scope.tracker.device.in_enabled_wz
            $scope.disableDOTAccess = $scope.tracker.device.disable_dot_access

            $scope.enableAlerts        = $scope.tracker.alerts_enabled
            $scope.liveTrackingPending = $scope.tracker.live_tracking_pending !== undefined && $scope.tracker.live_tracking_pending !== null

            if ($scope.tracker.meta.isTrackerTrucksEnter) {
                $scope.remoteOverridePending = $scope.tracker.trucks_enter.remote_override_pending !== undefined && $scope.tracker.trucks_enter.remote_override_pending !== null && $scope.tracker.trucks_enter.remote_override_pending
            }

            $scope.generalFormData = {
                name:        $scope.tracker.name,
                customer_id: $scope.tracker.device.customer_id
            }

            if ($scope.tracker.voltage_limit) {
                $scope.voltageLimit = {
                    warning:  $scope.tracker.voltage_limit.warning,
                    critical: $scope.tracker.voltage_limit.critical
                }
            }

            if ($scope.tracker.meta.isTrackerQwsSensor) {

                // $scope.sliderQwsSensorRange.minValue = $scope.tracker.qws_sensor.distance_min
                // $scope.sliderQwsSensorRange.maxValue = $scope.tracker.qws_sensor.distance_max

                $scope.newQwsSensorSettings = {
                    distance_min:     $scope.tracker.qws_sensor.distance_min,
                    distance_max:     $scope.tracker.qws_sensor.distance_max,
                    totaling_window:  $scope.tracker.qws_sensor.totaling_window,
                    min_active_speed: $scope.tracker.qws_sensor.min_active_speed
                }
            }

            if ($scope.tracker.meta.isTrackerTrucksEnter) {

                $scope.sliderBeaconsDuration.value = $scope.tracker.trucks_enter.beacons_duration

                $scope.newTrucksEnterSettings = {
                    trigger_direction:   $scope.tracker.trucks_enter.trigger_direction,
                    // classification_type: $scope.tracker.trucks_enter.classification_type,
                    beacons_duration:    $scope.tracker.trucks_enter.beacons_duration
                }
            }

            if ($scope.tracker.meta.isTrackerMarker) {

                $scope.newMarkerSettings = {
                    location_type: $scope.tracker.marker.location_type
                }
            }

            $scope.isEditSystemVoltage      = false
            $scope.isSettingSystemVoltage   = false
            $scope.isSettingVoltageLimit    = false
            $scope.isResettingActiveMinutes = false

            $scope.connectionFormData.deactivated = $scope.tracker.deactivated

        }

        const translateFeet = (value) => {
            return value + (value === 1 ? " foot" : " feet")
        }

        const translateSeconds = (value) => {
            return value + (value === 1 ? " second" : " seconds")
        }

        $scope.checkFormNeedsSave = () => {

            $scope.settingsNeedsSave = false

            if ($scope.tracker.meta.isTrackerQwsSensor) {
                // $scope.settingsNeedsSave = $scope.newQwsSettings.distance_min !== $scope.tracker.qws_sensor.distance_min
                // $scope.settingsNeedsSave = $scope.settingsNeedsSave || $scope.newQwsSensorSettings.distance_max     !== $scope.tracker.qws_sensor.distance_max
                $scope.settingsNeedsSave = $scope.settingsNeedsSave || $scope.newQwsSensorSettings.min_active_speed !== $scope.tracker.qws_sensor.min_active_speed
                $scope.settingsNeedsSave = $scope.settingsNeedsSave || $scope.newQwsSensorSettings.totaling_window  !== $scope.tracker.qws_sensor.totaling_window
            }

            if ($scope.tracker.meta.isTrackerTrucksEnter) {
                $scope.settingsNeedsSave = $scope.newTrucksEnterSettings.beacons_duration !== $scope.tracker.trucks_enter.beacons_duration
                $scope.settingsNeedsSave = $scope.settingsNeedsSave || $scope.newTrucksEnterSettings.trigger_direction   !== $scope.tracker.trucks_enter.trigger_direction
                // $scope.settingsNeedsSave = $scope.settingsNeedsSave || $scope.newTrucksEnterSettings.classification_type !== $scope.tracker.trucks_enter.classification_type
            }

            if ($scope.tracker.meta.isTrackerSolarLightTower) {
                $scope.settingsNeedsSave = $scope.newSolarLightTowerSettings.light_1_target_level !== $scope.tracker.solar_light_tower.light_1_target_level
                $scope.settingsNeedsSave = $scope.settingsNeedsSave || $scope.newSolarLightTowerSettings.light_2_target_level !== $scope.tracker.solar_light_tower.light_2_target_level
                $scope.settingsNeedsSave = $scope.settingsNeedsSave || $scope.newSolarLightTowerSettings.light_3_target_level !== $scope.tracker.solar_light_tower.light_3_target_level
                $scope.settingsNeedsSave = $scope.settingsNeedsSave || $scope.newSolarLightTowerSettings.light_4_target_level !== $scope.tracker.solar_light_tower.light_4_target_level
            }

            if ($scope.tracker.meta.isTrackerSpeedTrailer) {
                $scope.settingsNeedsSave = $scope.newSpeedTrailerSettings.report_interval !== $scope.tracker.speed_trailer.report_interval
                $scope.settingsNeedsSave = $scope.settingsNeedsSave || $scope.newSpeedTrailerSettings.speed_limit !== $scope.tracker.speed_trailer.speed_limit
                $scope.settingsNeedsSave = $scope.settingsNeedsSave || $scope.newSpeedTrailerSettings.excess_speed_delta !== $scope.tracker.speed_trailer.excess_speed_delta
                $scope.settingsNeedsSave = $scope.settingsNeedsSave || $scope.newSpeedTrailerSettings.under_speed !== $scope.tracker.speed_trailer.under_speed
                $scope.settingsNeedsSave = $scope.settingsNeedsSave || $scope.newSpeedTrailerSettings.mode !== $scope.tracker.speed_trailer.mode
                $scope.settingsNeedsSave = $scope.settingsNeedsSave || $scope.newSpeedTrailerSettings.excess_speed_pattern !== $scope.tracker.speed_trailer.excess_speed_pattern
            }

            if ($scope.tracker.meta.isTrackerMarker) {
                $scope.settingsNeedsSave = $scope.newMarkerSettings.location_type !== $scope.tracker.marker.location_type
            }
        }

        $scope.cleanTotalingWindow = () => {
            const input = document.getElementById("totaling_window")
            if (input !== undefined && input.value !== undefined) {
                $scope.newQwsSensorSettings.totaling_window = Number(input.value.replace(/\D/g, ""))
                input.value = $scope.newQwsSensorSettings.totaling_window
            }
            $scope.checkFormNeedsSave()
        }

        $scope.cleanMinimumActiveSpeed = () => {
            const input = document.getElementById("minimum_active_speed")
            if (input !== undefined && input.value !== undefined) {
                $scope.newQwsSensorSettings.min_active_speed = Number(input.value.replace(/\D/g, ""))
                input.value = $scope.newQwsSensorSettings.min_active_speed
            }
            $scope.checkFormNeedsSave()
        }

        $scope.cleanReportInterval = () => {
            const input = document.getElementById("report_interval")
            if (input !== undefined && input.value !== undefined) {
                $scope.newSpeedTrailerSettings.report_interval = Number(input.value.replace(/\D/g, ""))
                input.value = $scope.newSpeedTrailerSettings.report_interval
            }
            $scope.checkFormNeedsSave()
        }

        $scope.cleanSpeedLimit = () => {
            const input = document.getElementById("speed_limit")
            if (input !== undefined && input.value !== undefined) {
                $scope.newSpeedTrailerSettings.speed_limit = Number(input.value.replace(/\D/g, ""))
                input.value = $scope.newSpeedTrailerSettings.speed_limit
            }
            $scope.checkFormNeedsSave()
        }

        $scope.cleanExcessSpeedDelta = () => {
            const input = document.getElementById("excess_speed_delta")
            if (input !== undefined && input.value !== undefined) {
                $scope.newSpeedTrailerSettings.excess_speed_delta = Number(input.value.replace(/\D/g, ""))
                input.value = $scope.newSpeedTrailerSettings.excess_speed_delta
            }
            $scope.checkFormNeedsSave()
        }

        $scope.cleanUnderSpeed = () => {
            const input = document.getElementById("under_speed")
            if (input !== undefined && input.value !== undefined) {
                $scope.newSpeedTrailerSettings.under_speed = Number(input.value.replace(/\D/g, ""))
                input.value = $scope.newSpeedTrailerSettings.under_speed
            }
            $scope.checkFormNeedsSave()
        }

        $scope.sliderQwsSensorRange = {
            minValue: 0,
            maxValue: 1,
            options: {
                floor:            Min_Distance,
                ceil:             Max_Distance,
                precision:        2,
                step:             0.25,
                minRange:         0.25,
                pushRange:        true,
                getPointerColor:  () => { return "#0069aa" },
                onChange:         $scope.checkFormNeedsSave,
                translate:        translateFeet,
                disableAnimation: true
            }
        }

        $scope.sliderBeaconsDuration = {
            value: 0,
            options: {
                floor:            Min_BeaconActivation,
                ceil:             Max_BeaconActivation,
                precision:        0,
                step:             5,
                getPointerColor:  () => { return "#0069aa" },
                onChange:         $scope.checkFormNeedsSave,
                translate:        translateSeconds,
                disableAnimation: true
            }
        }

        $scope.systemVoltageOptions = [
            {
              name:  "12v",
              value: "12v"
            },
            {
              name:  "24v",
              value: "24v"
            }
        ]

        $scope.selectedSystemVoltage = $scope.systemVoltageOptions[0]

        $scope.trucksEnterDirections = [
            {
                name: "Approach"
            },
            {
                name: "Depart"
            },
            {
                name: "Both"
            }
        ]

        $scope.speedTrailerModes = [
            {
                name: "Off"
            },
            {
                name: "Display off with FM Radar Capture"
            },
            {
                name: "Speed Limit"
            },
            {
                name: "Speed Limit with FM Radar Capture"
            },
            {
                name: "Your Speed"
            },
            {
                name: "Your Speed with FM Radar Capture"
            }
        ]

        $scope.speedTrailerExcessSpeedPatterns = [
            {
                name: "Blank"
            },
            {
                name: "Diamond"
            },
            {
                name: "Bar"
            },
            {
                name: "Four Corners"
            },
            {
                name: "Wig Wag Animation"
            },
            {
                name: "Asterisks"
            }
        ]

        $scope.markerLocationTypes = [
            {
                name: "Generic"
            },
            {
                name: "Start"
            },
            {
                name: "End"
            }
        ]

        // $scope.trucksEnterClassifications = [
        //     {
        //         name: "Cars & Trucks",
        //         value: "CarsTrucks"
        //     },
        //     {
        //         name: "Trucks Only",
        //         value: "TrucksOnly"
        //     }
        // ]

        $scope.startEditGeneral = () => {
            $scope.isEditGeneral = true
        }

        $scope.editTrackerGeneral = () => {
            $scope.submitted = true
            if ($scope.editGeneralForm.$valid) {

                const success = (data) => {

                    userMessagingService.success("General Info Edit Successful")

                    if ($scope.tracker.name !== data.name) {
                        $rootScope.trackerName = data.name
                        $scope.tracker.name = data.name
                    }
                    if ($scope.tracker.device.customer_id !== data.device.customer_id) {
                        $scope.tracker.device.customer_id = data.device.customer_id
                        $scope.tracker.device.customer_name = data.device.customer_name
                        // $scope.getCustomer(data.device.customer_id)
                    }

                    $scope.isEditGeneral = false

                }

                const failure = (error) => {
                    userMessagingService.error(error)
                }

                trackersService.editTracker($stateParams.tracker_id, angular.fromJson($scope.generalFormData), success, failure)
            }
        }

        $scope.startEditSettings = () => {

            if ($scope.tracker.meta.isTrackerQwsSensor) {

                $scope.isEditQwsSensorSettings = true

            }

            if ($scope.tracker.meta.isTrackerTrucksEnter) {

                $scope.isEditTrucksEnterSettings = true

            }

            if ($scope.tracker.meta.isTrackerMarker) {

                $scope.isEditMarkerSettings = true

            }

            $timeout(() => {
                $scope.$broadcast('rzSliderForceRender')
            })

            $scope.checkFormNeedsSave()
            updateDisplay()

        }

        $scope.cancelEditSettings = () => {

            if ($scope.tracker.meta.isTrackerQwsSensor) {

                $scope.isEditQwsSensorSettings = false

            }

            if ($scope.tracker.meta.isTrackerTrucksEnter) {

                $scope.isEditTrucksEnterSettings = false

            }

            if ($scope.tracker.meta.isTrackerMarker) {

                $scope.isEditMarkerSettings = false

            }

            $scope.checkFormNeedsSave()
            updateDisplay()

        }

        $scope.editTrucksEnterSettings = () => {

            $scope.submitted = true
            $scope.setRequesting(true)

            const success = () => {

                $scope.isEditTrucksEnterSettings = false
                userMessagingService.success("Settings Update In Progress")

            }

            const failure = (error) => {
                $scope.setRequesting(false)
                userMessagingService.error(error)
            }

            trackersService.editTrucksEnterSettings($stateParams.tracker_id, $scope.newTrucksEnterSettings, success, failure)

        }

        $scope.editMarkerSettings = () => {

            $scope.submitted = true
            $scope.setRequesting(true)

            const success = () => {

                $scope.setRequesting(false)
                $scope.isEditMarkerSettings = false
                $scope.tracker.marker.location_type = $scope.newMarkerSettings.location_type
                userMessagingService.success("Marker Settings Updated")

            }

            const failure = (error) => {
                $scope.setRequesting(false)
                userMessagingService.error(error)
            }

            trackersService.editMarkerSettings($stateParams.tracker_id, $scope.newMarkerSettings, success, failure)

        }

        $scope.editQwsSensorSettings = () => {

            $scope.submitted = true
            $scope.setRequesting(true)

            const success = () => {

                $scope.isEditQwsSensorSettings = false
                userMessagingService.success("Settings Update In Progress")

            }

            const failure = (error) => {
                $scope.setRequesting(false)
                userMessagingService.error(error)
            }

            trackersService.editQwsSensorSettings($stateParams.tracker_id, $scope.newQwsSensorSettings, success, failure)

        }

        $scope.toggleTrucksEnterRemoteOverride = () => {

            $scope.setRequesting(true)

            const success = (response) => {
                $scope.isEditTrucksEnterSettings = false
                $scope.tracker.trucks_enter.remote_override_pending = response.remote_override_pending
                $scope.remoteOverridePending = response.remote_override_pending
            }

            const failure = () => {

                $scope.setRequesting(false)
                let message = "Enable"
                if ($scope.tracker.trucks_enter.remote_override_pending) {
                    message = "Disable"
                }
                userMessagingService.error("Failed to " + message + " Remote Override. If this issue persists, please contact Wanco Support for assistance.")

            }

            trackersService.setTrucksEnterRemoteOverride($stateParams.tracker_id, !$scope.tracker.trucks_enter.remote_override, success, failure)

        }

        $scope.toggleEnableAlerts = () => {

            $scope.enableAlerts = !$scope.enableAlerts

            trackersService.setEnableAlerts($stateParams.tracker_id, $scope.enableAlerts, undefined, () => {
                $scope.enableAlerts = !$scope.enableAlerts
                let message = "Enable"
                if ($scope.enableAlerts) {
                    message = "Disable"
                }
                userMessagingService.error("Failed to " + message + " Alerts. If this issue persists, please contact Wanco Support for assistance.")
            })
        }

        $scope.toggleActiveUseInWZ = () => {

            if ($scope.inEnabledWZ || $scope.disableDOTAccess) { return }

            $scope.activeUseInWZ = !$scope.activeUseInWZ

            const failure = () => {

                $scope.activeUseInWZ = !$scope.activeUseInWZ

                let message = "Activate"

                if ($scope.activeUseInWZ) {
                    message = "Deactivate"
                }

                userMessagingService.error("Failed to " + message + " Use In WZ. If this issue persists, please contact Wanco Support for assistance.")

            }

            devicesService.setActiveUseInWZ($scope.tracker.device.id, $scope.activeUseInWZ, undefined, failure)

        }

        $scope.toggleDisableDOTAccess = () => {

            if ($scope.activeUseInWZ || $scope.inEnabledWZ) { return }

            $scope.disableDOTAccess = !$scope.disableDOTAccess

            const failure = () => {

                $scope.disableDOTAccess = !$scope.disableDOTAccess

                let message = "Enable"

                if ($scope.disableDOTAccess) {
                    message = "Disable"
                }

                userMessagingService.error("Failed to " + message + " DOT Access. If this issue persists, please contact Wanco Support for assistance.")

            }

            devicesService.setDisableDOTAccess($scope.tracker.device.id, $scope.disableDOTAccess, undefined, failure)

        }

        $scope.toggleLiveTracking = () => {

            if ($scope.tracker.meta.isAlwaysOn) {
                $scope.setRequesting(true)
            }

            const success = (response) => {
                if ($scope.tracker.meta.isAlwaysOn) {
                    $scope.isEditTrucksEnterSettings = false
                }
                $scope.tracker.live_tracking_pending = response.live_tracking_pending
                $scope.liveTrackingPending = $scope.tracker.live_tracking_pending !== undefined && $scope.tracker.live_tracking_pending !== null
            }

            const failure = () => {

                $scope.setRequesting(false)
                let message = "Enable"
                if ($scope.tracker.live_tracking) {
                    message = "Disable"
                }
                userMessagingService.error("Failed to " + message + " Live Tracking. If this issue persists, please contact Wanco Support for assistance.")

            }

            trackersService.setLiveTracking($stateParams.tracker_id, !$scope.tracker.live_tracking, success, failure)

        }

        $scope.refreshSettings = () => {

            if ($scope.tracker.meta.isAlwaysOn === true) {

                if (!$scope.isRequesting) {

                    $scope.cancelEditSettings()
                    $scope.setRequesting(true)

                    const success = () => {}

                    const failure = (error) => {
                        $scope.setRequesting(false)
                        userMessagingService.error(error)
                    }

                    telemetryService.refreshSettings($scope.tracker.type, $scope.tracker.id, success, failure)

                }
            }
        }

        $scope.rebootController = () => {

            if ($scope.tracker.meta.isTrackerSunTech && !$scope.tracker.meta.isTrackerGeneric) {

                if (!$scope.isRequesting) {

                    $scope.cancelEditSettings()
                    $scope.setRequesting(true)

                    const success = () => {
                        userMessagingService.success("Reboot Controller Request Sent")
                    }

                    const failure = (error) => {
                        $scope.setRequesting(false)
                        userMessagingService.error(error)
                    }

                    trackersService.rebootController($scope.tracker.id, success, failure)

                }
            }
        }

        $scope.openResetCounterModal = () => {

            if (!$scope.isRequesting) {

                $scope.setRequesting(true)

                const onSuccess = () => {
                    $scope.tracker.trucks_enter.vehicle_count = 0
                }

                const onFailure = (error) => {
                    $scope.setRequesting(false)
                    userMessagingService.error(error)
                }

                $uibModal.open({
                    templateUrl: "app/modals/reset-vehicle-counter.view.html",
                    controller: "ResetVehicleCounterController",
                    resolve: {
                        trackerID: () => {
                            return $stateParams.tracker_id
                        },
                        onSuccess: () => {
                            return onSuccess
                        },
                        onFailure: () => {
                            return onFailure
                        }
                    }
                }).result.catch((res) => {
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
            }
        }

        $scope.openResetActiveMinutesModal = (resetLifetime) => {

            if (!$scope.isRequesting) {

                $scope.isResettingActiveMinutes = true
                $scope.setRequesting(true)

                const onSuccess = () => {}

                const onFailure = (error) => {
                    $scope.setRequesting(false)
                    $scope.isResettingActiveMinutes = false
                    userMessagingService.error(error)
                }

                $uibModal.open({
                    templateUrl: "app/modals/reset-display-minutes.view.html",
                    controller: "ResetDisplayMinutesController",
                    resolve: {
                        trackerID: () => {
                            return $stateParams.tracker_id
                        },
                        onSuccess: () => {
                            return onSuccess
                        },
                        onFailure: () => {
                            return onFailure
                        },
                        onReset: () => {
                            return () => {
                                setTimeout(() => {
                                    // Super Hack for Request Timed Out
                                    if ($scope.isResettingActiveMinutes) {
                                        $scope.isResettingActiveMinutes = false
                                    }
                                }, 25000)
                            }
                        },
                        onCancel: () => {
                            return () => {
                                $scope.setRequesting(true)
                                $scope.isResettingActiveMinutes = false
                            }
                        },
                        resetLifetime: () => {
                            return resetLifetime === true
                        }
                    }
                }).result.catch((res) => {
                    $scope.setRequesting(false)
                    $scope.isResettingActiveMinutes = false
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
            }
        }

        $scope.showEditSystemVoltage = (val) => {
            $scope.isEditSystemVoltage = val
        }

        $scope.setSystemVoltage = (selectedSystemVoltage) => {

            const success = (data) => {
                $scope.tracker = data
                updateDisplay()
            }

            const failure = () => {
                userMessagingService.error("Set System Voltage Failed")
                updateDisplay()
            }

            $scope.isSettingSystemVoltage = true

            trackersService.setSystemVoltage($scope.tracker.id, selectedSystemVoltage.value, success, failure)

        }

        $scope.startEditVoltageLimit = () => {
            $scope.isEditVoltageLimit = true
        }

        $scope.setVoltageLimits = () => {

            const success = (data) => {
                $scope.tracker = data
                updateDisplay()
            }

            const failure = () => {
                userMessagingService.error("Set Voltage Limits Failed")
                updateDisplay()
            }

            $scope.isSettingVoltageLimit = true
            $scope.isEditVoltageLimit    = false

            trackersService.setVoltageLimits($scope.tracker.id, String($scope.voltageLimit.warning), String($scope.voltageLimit.critical), success, failure)

        }

        $scope.toggleActivated = () => {
            $scope.connectionFormData.deactivated = !$scope.connectionFormData.deactivated
        }

        $scope.toggleShowEditConnection = () => {
            $scope.connectionFormData.deactivated = $scope.tracker.deactivated
            $scope.editConnection = !$scope.editConnection
            $scope.isEditGeneral = false
        }

        $scope.editTrackerConnection = () => {

            if ($scope.tracker.meta.isWzOutput || $scope.tracker.meta.isWzInput) {
                userMessagingService.error("Tracker is Read Only")
                return
            }

            const success = () => {

                userMessagingService.success("Connection Edit Successful")

                $scope.tracker.deactivated = $scope.connectionFormData.deactivated

                $scope.editConnection = false

            }

            const failure = () => {
                userMessagingService.error("Connection Edit Failed")
            }

            console.log($scope.connectionFormData.deactivated)
            trackersService.editTrackerConnection($stateParams.tracker_id, $scope.connectionFormData, success, failure)

        }

        const notesClearNew = () => {
            $scope.notesAddNew         = false
            $scope.notesAddNewPrivate  = false
            $scope.notesNewText        = ""
            $scope.notesNewTextPrivate = ""
        }

        const notesUpdateDisplay = (notes) => {

            notes.sort((a, b) => { return a.created_at < b.created_at })

            $scope.tracker.device.notes         = notes
            $scope.tracker.device.notes_public  = $scope.tracker.device.notes.filter((n) => { return !n.private })
            $scope.tracker.device.notes_private = $scope.tracker.device.notes.filter((n) => { return n.private })

            setTimeout(() => {
                $scope.$apply(() => {
                    for (const note of $scope.tracker.device.notes) {
                        const elem = document.getElementById("noteContent" + note.id)
                        if (elem) {
                            elem.innerHTML = notesService.formatContentForDisplay(note.text)
                        }
                    }
                })
            }, 1)
        }

        $scope.notesShowAddNew = (priv) => {
            if (priv) {
                $scope.notesNewTextPrivate = ""
                $scope.notesAddNewPrivate  = true
            } else {
                $scope.notesNewText = ""
                $scope.notesAddNew  = true
            }
        }

        $scope.notesSave = (priv, text) => {

            if (priv && !$rootScope.can('SystemNotePrivateCreate', $scope.tracker.device.customer_id)) {
                return
            }

            const success = (notes) => {
                notesClearNew()
                notesUpdateDisplay(notes)
            }

            const failure = () => {
                notesClearNew()
                userMessagingService.error("Create Note Failed")
            }

            notesService.createNote($scope.tracker.device.id, "Device", text, priv, success, failure)

        }

        $scope.notesDelete = (noteID) => {

            const success = (notes) => {
                notesUpdateDisplay(notes)
            }

            const failure = () => {
                userMessagingService.error("Delete Note Failed")
            }

            notesService.deleteNote(noteID, success, failure)

        }

        $scope.$watch("$root.pushedData", (pushedData) => {

            if ($scope.tracker.hasOwnProperty("device")) {

                if (pushedData.device.hasOwnProperty("device") && pushedData.device.device.hasOwnProperty("id")) {

                    if (pushedData.device.device.id === $scope.tracker.device.id) {
                        updateDisplay()
                    }

                } else if (pushedData.hasOwnProperty("deviceID")) {

                    if (pushedData.deviceID === $scope.tracker.device.id) {
                        updateDisplay()
                    }
                }
            }
        })

        $scope.$watch("retrievedTracker", (retrievedTracker) => {

            if (retrievedTracker) {
                updateDisplay()
                notesUpdateDisplay($scope.tracker.device.notes)
            }
        })

    }
})()
